/**
 * In some cases brooklyn contentType represents a few YI content types (for example brooklyn contentType "video" represenets YI "class" and "meditation")
 * ContentType represenets more focused content types
 * */
export enum ContentType {
  'YI_CLASS' = 'YI_CLASS',
  'YI_MEDITATION' = 'YI_MEDITATION',
  'YI_COURSE' = 'YI_COURSE',
  'YI_COURSE_SECTION' = 'YI_COURSE_SECTION',
  'YI_COURSE_MODULE' = 'YI_COURSE_MODULE',
  // NOTE: Gaia content is out of scope
  // 'GAIA_VIDEO' = 'GAIA_VIDEO',
  'YI_POSE' = 'YI_POSE',
  'YI_ARTICLE' = 'YI_ARTICLE',
  'YI_COURSE_SALES' = 'YI_COURSE_SALES',
  'YI_MEMBERSHIP_PROMO' = 'YI_MEMBERSHIP_PROMO',
  'YI_HOMEPAGE_HERO' = 'YI_HOMEPAGE_HERO',
  'YI_SERIES' = 'YI_SERIES',
  'YI_SERIES_EPISODE' = 'YI_SERIES_EPISODE',
  'YI_TEACHER' = 'YI_TEACHER',
  'YI_TAG' = 'YI_TAG',
  'YI_TAG_GROUP' = 'YI_TAG_GROUP',
}

export enum YI_CONTENT_TYPE_TAG {
  CLASS = 'Class',
  MEDITATION = 'Meditation',
  PREMIUM_TRAINING = 'Premium Training',
  CHALLENGE = 'Challenge',
  PODCAST = 'Podcast',
  WORKSHOP = 'Workshop',
  COURSE_MODULE_GROUP = 'Course Module Group',
  COURSE_MODULE = 'Course Module',
  POSE = 'Pose',
  ARTICLE = 'Article',
  COURSE_SALES_PAGE = 'Course Sales Page',
  MEMBER_PROMO = 'Membership Promo',
  HOMEPAGE_HERO = 'Homepage Hero Content',
  SERIES = 'Series',
  SERIES_EPISODE = 'Series Episode',
  TEACHER = 'Teacher',
  TAG = 'Tag',
  TAG_GROUP = 'Tag Group',
}
